export default {
    setUserRole() {

    }
}
